import { FC } from "react";
// import DateRange from "./DateRange";
import Stats from "./Stats";
import OutputMenu from "./OutputMenu";

const RightSidebar: FC = () => {
	return (<>
		<OutputMenu />
		<Stats />
		{/* <DateRange /> */}
	</>);
};


export default RightSidebar;